'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'SearchBar';

export enum OFFICIAL_SEARCH_BAR_KEY {
    STYLE_1 = 'official-search-bar-style-1',
    STYLE_2 = 'official-search-bar-style-2',
    STYLE_3 = 'official-search-bar-style-3',
    STYLE_4 = 'official-search-bar-style-4',
}

export const searchBarTypeKey = {
    style1: 'style-1',
    style2: 'style-2',
    style3: 'style-3',
    style4: 'style-4',
} as const;

export const showCutList = [
    {
        key: OFFICIAL_SEARCH_BAR_KEY.STYLE_1,
        type: ELEMENT_TYPE.SEARCH_BAR,
        content: i18n.gettext('搜尋匡'),
        version: 1,
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.SEARCH_BAR,
    name: componentName,
    enable: true,
    next: null,
    deletable: true,
};

export const features = [
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.SEARCH_BOX_TYPE,
    FEATURE_FLAG_KEYS.SEARCH_BOX_BACKGROUND_COLOR,
    FEATURE_FLAG_KEYS.SEARCH_BOX_BORDER_COLOR,
    FEATURE_FLAG_KEYS.SEARCH_BOX_BORDER_RADIUS,
    FEATURE_FLAG_KEYS.FONT_COLOR,
    FEATURE_FLAG_KEYS.RICH_TEXT,
    FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_COLOR,
    FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BACKGROUND_COLOR,
    FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BORDER_COLOR,
    FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BORDER_RADIUS,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.SEARCH_BOX_TYPE]: searchBarTypeKey.style1,
    [FEATURE_FLAG_KEYS.SEARCH_BOX_BACKGROUND_COLOR]: 'rgba(238, 238, 239, 1)',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_BORDER_RADIUS]: '4px',
    [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(124, 124, 128, 1)',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_COLOR]: 'rgba(238, 238, 239, 1)',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BACKGROUND_COLOR]: 'rgba(68, 112, 226, 1)',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BORDER_RADIUS]: '4px',
} as const;

export function createSearchBar(
    presetConfig?: Partial<typeof config>,
    presetStyle?: LayoutNodeStyleMap[string]
) {
    const id = getElementUlId();

    const layout = {
        ...config,
        ...presetConfig,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
        content: i18n.gettext('搜尋關鍵字'),
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    options?: { shouldWrap?: boolean }
) {
    const searchBar = createSearchBar();

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [searchBar], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL, // 依照需求調整 grid type
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL, // 依照需求調整 grid type
        shouldWrap,
    });
}
